<div class="policy-outer">
    <div class="policy-wraper custom-terms-condition">
        <div class="logo-inner">
            <img src="assets/images/terms-logo.png" alt="Terms logo"/>
        </div>
        <h2>Terms and Conditions </h2>
        <h4>Last updated: March 6, 2024</h4>
        <p>
            Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using
            trucklots.com (the "Service") operated by Trucklots ("us", "we", or "our").
        </p>
        <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
            These Terms apply to all visitors, users, and others who access or use the Service.</p>
        <p>By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the
            terms, then you may not access the Service.</p>

<div class="pricing-outer">
            <h3>Accounts </h3>
            <p>When you create an account with us, you must provide us with information that is accurate, complete, and
                current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate
                termination of your account on our Service.</p>
            <p>You are responsible for safeguarding the password that you use to access the Service and for any
                activities or actions under your password, whether your password is with our Service or a third-party
                service.</p>
            <p>You agree not to disclose your password to any third party. You must notify us immediately upon becoming
                aware of any breach of security or unauthorized use of your account.</p>
        </div>

        <div class="pricing-outer">
            <h3>Links To Other Web Sites </h3>
            <p>Our Service may contain links to third-party web sites or services that are not owned or controlled by
                Trucklots.</p>
            <p>Trucklots has no control over, and assumes no responsibility for, the content, privacy policies, or
                practices of any third-party web sites or services. You further acknowledge and agree that Trucklots
                shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to
                be caused by or in connection with use of or reliance on any such content, goods or services available
                on or through any such web sites or services.</p>
            <p>We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites
                or services that you visit.</p>
        </div>
        <div class="pricing-outer">
            <h3>Termination </h3>
            <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any
                reason whatsoever, including without limitation if you breach the Terms.</p>
            <p>All provisions of the Terms which by their nature should survive termination shall survive termination,
                including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of
                liability.</p>

        </div>
        <div class="pricing-outer">
            <h3>Governing Law </h3>
            <p>These Terms shall be governed and construed in accordance with the laws of the United States, without
                regard to its conflict of law provisions.</p>
            <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those
                rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining
                provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us
                regarding our Service, and supersede and replace any prior agreements we might have between us regarding
                the Service.</p>

        </div>
        <div class="pricing-outer">
            <h3>Changes </h3>
            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision
                is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What
                constitutes a material change will be determined at our sole discretion.</p>
            <p>By continuing to access or use our Service after those revisions become effective, you agree to be bound
                by the revised terms. If you do not agree to the new terms, please stop using the Service</p>

        </div>
        <div class="pricing-outer">
            <h3>SMS Communication Privacy Policy</h3>
            <p>Your privacy is important to us. By providing your mobile number, you agree to receive SMS messages from
                us containing updates, notifications, and promotions regarding our services. Rest assured, we do not
                share your information for marketing purposes. You have the option to opt out at any time. Safeguarding
                your data security is our top priority.</p>
        </div>  
        <div class="pricing-outer">
            <h3>Recurring Payment Consent</h3>
            <p>By using recurring booking option, you agree to authorize Trucklots to initiate recurring charges from
                the payment method you have provided. These charges will occur on the agreed-upon schedule and amount
                until you cancel your subscription or contact customer support. You acknowledge your responsibility to
                ensure accurate payment and contact information. </p>
        </div>
        <div class="pricing-outer">
            <h3>Contact Us </h3>
            <p>If you have any questions about these Terms, please contact us.</p>
        </div>

    </div>

</div>